import {forwardRef, useRef, Ref, useImperativeHandle} from 'react';

import Loader, {ILoaderRef} from '../loader/Loader';

import './ButtonLoader.scss'

export interface IButtonLoaderRef {
    showLoader(value: boolean): void;
}

export interface IButtonLoader {
    className?: string;
    children?: React.ReactNode,
    onClick?: () => void
}

const ButtonLoader = forwardRef((props: IButtonLoader, ref: Ref<IButtonLoaderRef>) => {

    const loader = useRef<ILoaderRef>(null);

    useImperativeHandle(ref, () => ({showLoader}));

    function showLoader(value: boolean): void {
        if (loader != null) {
            loader.current?.showLoader(value);
        }
    }

    return (
        <div className="button_loader_container">

            <button className={props.className ? props.className : ''} onClick={props.onClick ? props.onClick : () => {
            }}>
                {props.children}
            </button>

            <Loader ref={loader}/>

        </div>
    )
})

export default ButtonLoader;
